import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import React, { act } from "react";
import { PostSliceState } from "../../Slices/postSlice";
import { PaginationType } from "../../../dto/Pagination.dto";
import { showErrorToast } from "../../../app/utils/common/Toast";
import { getRegistrationRequestsAPI } from "../../API/RegistrationRequestAPI";
import { RegristrationRequestType } from "../../../dto/RegistrationRequest.dto";
import { RegistrationReqSliceState } from "../../Slices/registrationRequestSlice";
import { showErrorResponse } from "../../../app/utils/common/showErrorMessage";

export const RegistrationRequestReducer = (
  builder: ActionReducerMapBuilder<RegistrationReqSliceState>
) => {
  builder
    .addCase(getRegistrationRequestsAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      getRegistrationRequestsAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          user_data: RegristrationRequestType[];
          pagination: PaginationType;
          status: string;
        }>
      ) => {
        if (
          action.payload.pagination.current_page ===
          state.pagination.current_page
        ) {
          //   if (action.payload.status === "pending") {
          state.requests = action.payload?.user_data;
          state.pagination = action.payload.pagination;
          //   }
          //   state.pagination = action.payload.pagination;
          state.loading = false;
        }
      }
    )
    .addCase(
      getRegistrationRequestsAPI.rejected,
      (state, action: PayloadAction<any>) => {
        showErrorResponse(action.payload);
      }
    );
};
